<template>
  <div class="data-management single-sample-flow-page">
    <div class="well-top-wrap no-bg no-border no-padding mb-2">
      <h6>Assets</h6>
    </div>
    <v-row no-gutters>
      <GridLoaders v-if="showLoader == true" />
      <v-col v-else-if="assets.length > 0" v-for="(asset, index) in filteredAssets" :key="index" cols="12" md="6" lg="3" xl="3"
        >
        <v-sheet class="mb-4 pr-4 assets-card-sheet" @click="navigateToFields(asset)">
          <v-card elevation="3" class="v-card-asset">
            <v-card-title class="assets_name">
              Asset : {{ asset.name }}
            </v-card-title>
            <v-card-text class="assets-data">
              <div class="top-info">
                <div class="go-link go-link-with-chevron d-flex align-center justify-space-between flex-nowrap" @click.stop="navigateToFields(asset)">
                  <span class="go-link-label">Field <span>{{ asset.counts.fields }}</span></span>
                  <v-icon class="flex-shrink-0 single-sample-card-chevron" icon="mdi-chevron-right" size="20" />
                </div>
                <div>Well <span>{{ asset.counts.wells }}</span></div>
                <div>Sample <span>{{ asset.counts.samples }}</span></div>
                <div>Tests <span>{{ asset.counts.totalTests }}</span></div>
              </div>
              <div class="test-count">
                <div>Compositions <span>{{ asset.counts.compositions }}</span></div>
                <div>Separator Tests <span>{{ asset.counts.separatortests }}</span></div>
                <div>CCE Tests <span>{{ asset.counts.ccetests }}</span></div>
                <div>Viscosity Tests <span>{{ asset.counts.viscositytests }}</span></div>
                <div>DL Tests <span>{{ asset.counts.dltests }}</span></div>
                <div>CVD Tests <span>{{ asset.counts.cvdtests }}</span></div>
              </div>
            </v-card-text>
          </v-card>
        </v-sheet>
      </v-col>
      <div v-else-if="timeoutMessage != ''" class="no-asset-div timeout">
        <div class="text-center">
          {{ timeoutMessage }}
          <v-icon flat @click="getAllAssets()" color="blue-darken-3" icon="mdi-reload" size="large"></v-icon>
        </div>
      </div>
      <div class="no-asset-div" v-else-if="assets.length == 0 && showLoader == false && timeoutMessage == ''
        ">
        <h4>No asset(s) found.</h4>
      </div>
    </v-row>
  </div>
</template>

<script>
import api from "../../../axiosInterceptor";
import GridLoaders from "../Loaders/GridLoaders.vue";
import { mapGetters } from "vuex";

export default {
  name: "SampleAssets",
  components: {
    GridLoaders,
  },
  data: () => ({
    assets: [],
    showLoader: false,
    timeoutMessage: "",
  }),
  computed: {
    ...mapGetters("tenantId", ["getSelectedTenant"]),
    filteredAssets() {
      return this.assets?.filter((asset) => asset.name);
    },
  },
  methods: {
    getAllAssets() {
      this.showLoader = true;
      this.assets = [];
      this.timeoutMessage = "";

      api
        .get("public/api/locations/assets")
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.assets = response.data.data.locations.sort((a, b) => {
              const nameA = a.name ? a.name.toLowerCase() : "";
              const nameB = b.name ? b.name.toLowerCase() : "";
              return nameA.localeCompare(nameB);
            });
          }
          else if (response && response.data && response.data.message) {
        this.timeoutMessage = response.data.message;
          }
          else {
            this.timeoutMessage = "Error in fetching assets";
          }
        })
        .catch((error) => {
          this.timeoutMessage = error;
        })
        .finally(() => {
          this.showLoader = false;
        });
    },
    navigateToFields(asset) {
      const sanitizedAssetName = asset.name.replace(/\//g, "\\");
      this.$router.push({
        name: "Fields",
        params: { asset: sanitizedAssetName },
      });
    },
  },
  watch: {
    getSelectedTenant: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getAllAssets();
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.single-sample-flow-page .go-link-with-chevron {
  width: 100%;
  gap: 6px;
}
.single-sample-flow-page .go-link-label {
  min-width: 0;
}

.well-top-wrap.no-bg.no-border {
  border: none !important;
  background-color: transparent !important;
}

.well-top-wrap.no-bg.no-border.no-padding {
  padding: 0px !important;
}
</style>
